<template>
  <div class="container-fluid">
    <div class="page-title">
      <i class="fa-regular fa-address-card"></i>
      <h1>{{ $t("COMMON.SUBSCRIPTIONS") }}</h1>
    </div>
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">{{ $t("SUBSCRIPTIONS.SUBSCRIPTIONS_LIST") }}</h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openSubscriptionCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_SUBSCRIPTIONS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">
                {{ $t("SUBSCRIPTIONS.ADD_SUBSCRIPTION") }}
              </span>
            </base-button>
            <!--<notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_SUBSCRIPTIONS)"
              :objectType="'subscriptions'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />-->
          </div>
        </div>
      </div>

      <subscription-list-table
        @onViewSubscription="openSubscriptionViewModal"
        @onEditSubscription="openSubscriptionEditModal"
        @onDeleteSubscription="deleteSubscription"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewSubscriptionModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewSubscriptionModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'SUBSCRIPTION'"
          @onCloseModal="closeSubscriptionModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SUBSCRIPTIONS.VIEW_SUBSCRIPTION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openSubscription"
                :objectType="'subscriptions'"
                :objectId="openSubscription.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="edit"
                  @click="openSubscriptionEditModal(openSubscription)"
                >
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <!-- <button class="edit" @click="deleteSubscription(openSubscription)">
              <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
            </button> -->
              </base-dropdown>
              <button class="close" @click="closeSubscriptionModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-subscription-page
              v-if="openSubscription"
              :subscriptionId="openSubscription.id"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditSubscriptionModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditSubscriptionModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'SUBSCRIPTION'"
          @onCloseModal="closeSubscriptionModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("SUBSCRIPTIONS.EDIT_SUBSCRIPTION") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button
                class="close"
                @click="openSubscriptionViewModal(openSubscription)"
              >
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-subscription-page
              v-if="openSubscription"
              :subscriptionId="openSubscription.id"
              @onViewSubscription="openSubscriptionViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddSubscriptionModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddSubscriptionModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'SUBSCRIPTION'"
          @onCloseModal="closeSubscriptionModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <h1>
              {{ $t("SUBSCRIPTIONS.ADD_SUBSCRIPTION") }}
            </h1>
            <button class="close" @click="closeSubscriptionModal(true)">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-subscription-page
              @onViewSubscription="openSubscriptionViewModal"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import requestErrorMixin from "@/mixins/request-error-mixin";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SubscriptionListTable from "./partials/SubscriptionListTable.vue";
import EditSubscriptionPage from "./components/EditSubscriptionComponent.vue";
import AddSubscriptionPage from "./components/AddSubscriptionComponent.vue";
import ViewSubscriptionPage from "./components/ViewSubscriptionComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    SubscriptionListTable,
    NotificationSubscription,
    EditSubscriptionPage,
    AddSubscriptionPage,
    ViewSubscriptionPage,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const locationId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewSubscriptionModalOpened = false;
    let isEditSubscriptionModalOpened = false;
    let isAddSubscriptionModalOpened = false;
    let openSubscription = null;
    if (locationId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewSubscriptionModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditSubscriptionModalOpened = true;
      }
      openSubscription = { id: locationId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddSubscriptionModalOpened = true;
    }
    return {
      isViewSubscriptionModalOpened: isViewSubscriptionModalOpened,
      isEditSubscriptionModalOpened: isEditSubscriptionModalOpened,
      isAddSubscriptionModalOpened: isAddSubscriptionModalOpened,
      openSubscription: openSubscription,
      renderKey: 1,
    };
  },

  methods: {
    openSubscriptionCreateModal() {
      this.closeSubscriptionModal();
      this.isAddSubscriptionModalOpened = true;

      this.$router.replace({
        name: "List Subscriptions",
        query: { action: QUERY_ACTIONS_ADD },
      });
    },
    openSubscriptionViewModal(subscription, reRender = false) {
      this.closeSubscriptionModal();
      this.openSubscription = subscription;
      this.isViewSubscriptionModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      this.$router.replace({
        name: "List Subscriptions",
        query: { id: this.openSubscription.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    openSubscriptionEditModal(subscription) {
      this.closeSubscriptionModal();
      this.openSubscription = subscription;
      this.isEditSubscriptionModalOpened = true;

      this.$router.replace({
        name: "List Subscriptions",
        query: { id: this.openSubscription.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    closeSubscriptionModal(goBack = false, grid = false) {
      if (goBack && this.$store.getters["routes/previousPathRoute"]) {
        if (grid) {
          this.$store.dispatch("routes/goBackToPreviousGrid");
        } else {
          this.$store.dispatch("routes/goToPreviousPath");
        }
        return;
      }
      this.isAddSubscriptionModalOpened = false;
      this.isViewSubscriptionModalOpened = false;
      this.isEditSubscriptionModalOpened = false;
      this.openSubscription = null;

      // if (
      //   this.$route.name !== "List Subscriptions" ||
      //   JSON.stringify(this.$route.query) !== JSON.stringify({})
      // ) {
      //   this.$router
      //     .replace({
      //       name: "List Subscriptions",
      //       query: {},
      //     })
      //     .catch((err) => {
      //       if (err.name !== "NavigationDuplicated") {
      //         throw err;
      //       }
      //     });
      // }
    },

    async deleteSubscription(subscription) {
      const confirmation = await swal.fire({
        title: this.$t("SUBSCRIPTIONS.DELETE_THIS_SUBSCRIPTION"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch("subscriptions/destroy", subscription.id);
          this.renderKey++;
          this.closeSubscriptionModal();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("SUBSCRIPTIONS.SUBSCRIPTION_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
